import React, { memo, useEffect, useRef, useState } from 'react';
import styles from './CoverSearch.module.less';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';
import { CONTEXT } from '../../config';
import { logPostInfo, logging } from '../../actions/log';
import { useHistory, useLocation } from 'react-router-dom';
import { logNative } from '../../utils/utils';

const selectHotSearchBox = createSelector(
  state => state.search,
  search => ({
    hotSearch: search.hotSearch,
    hotSearchApp: search.hotSearchApp,
    searchBarWordList: search.searchBarWordList,
  }),
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default memo(({ isCoverSearch, isWhite, getPlaceHolder }) => {
  const { searchBarWordList } = useSelector(selectHotSearchBox);
  const searchBarWordListRef = useRef(null);
  const location = useLocation();
  const node = useRef(null);
  const logInfoData = useSelector(selectLogInfo);
  const [innerHTML, setInnerHTML] = useState(null);

  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    if (
      innerHTML &&
      searchBarWordListRef.current &&
      Object.keys(searchBarWordListRef.current).length >= 1
    ) {
      dispatch(
        logging({
          category: 'I',
          action: `Search_Title`,
          label: '',
          param2: {
            source: logInfoData.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            search_type: 7,
            search_word: innerHTML,
          },
        }),
      );
    }
  }, [innerHTML]);
  useEffect(() => {
    searchBarWordListRef.current = searchBarWordList;
  }, [searchBarWordList]);
  useEffect(() => {
    if (!searchBarWordListRef.current || Object.keys(searchBarWordListRef.current).length < 1) {
      setInnerHTML('搜索商店内应用');
      return;
    }
    const urlMap = [
      {
        url: `${CONTEXT}/game`,
        key: 'game',
      },
      {
        url: `${CONTEXT}/education`,
        key: 'edu',
      },
      {
        url: `${CONTEXT}/edudetail`,
        key: 'edu',
      },
      {
        url: `${CONTEXT}/work`,
        key: 'office',
      },
    ];
    const target = urlMap.filter(item => location.pathname.indexOf(item.url) > -1);
    let targetHTML = ['搜索商店内应用'];
    if (target && target[0]) {
      targetHTML = searchBarWordListRef.current[target[0].key];
    } else {
      targetHTML = searchBarWordListRef.current.default;
    }
    try {
      targetHTML = JSON.parse(targetHTML);
    } catch (err) {
      targetHTML = ['搜索商店内应用'];
      logNative(`解析搜索栏词报错${searchBarWordListRef.current[target[0].key]} 错误${err}`);
    }
    targetHTML = targetHTML[Math.floor(Math.random() * (targetHTML && targetHTML.length))];
    setInnerHTML(targetHTML);
  }, [location.pathname, Object.keys(searchBarWordList || {}).length]);

  useEffect(() => {
    if (innerHTML) {
      let value = innerHTML;
      if (innerHTML.indexOf('<a>') > -1 && innerHTML.indexOf('</a>') > -1) {
        try {
          // eslint-disable-next-line prefer-destructuring
          value = innerHTML.split('<a>')[1];
          // eslint-disable-next-line prefer-destructuring
          value = value.split('</a>')[0];
        } catch (err) {
          value = '';
        }
      }
      getPlaceHolder(value);
    }
  }, [innerHTML]);

  if (!isCoverSearch) {
    return null;
  }

  return (
    <div className={`${styles.content} ${isWhite ? styles.white : ''}`}>
      <div dangerouslySetInnerHTML={{ __html: innerHTML }} className={styles.content_detail} />
    </div>
  );
});
